var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHtml(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "ViewHtml",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1131",
    "data-name": "Rectangle 1131",
    width: 32,
    height: 32,
    transform: "translate(-1 1)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_42",
    "data-name": "Mask Group 42",
    transform: "translate(1 -1)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "edit_square_FILL0_wght400_GRAD0_opsz48",
    d: "M121.714,238.679A1.757,1.757,0,0,1,120,236.965V219.827a1.757,1.757,0,0,1,1.714-1.714h17.5l-.366,1.714H121.714v17.138h17.138V219.827s-.518-1.754.366-1.714a1.641,1.641,0,0,1,1,.514,2.787,2.787,0,0,1,.345,1.2v17.138a1.757,1.757,0,0,1-1.714,1.714Z",
    transform: "translate(-118.773 -212.84)",
    fill: "#0073b2"
  }), /*#__PURE__*/React.createElement("text", {
    id: "_",
    "data-name": "</>",
    transform: "translate(5.509 18.5)",
    fill: "#0073b2",
    fontSize: 8,
    fontFamily: "OpenSans-Bold, Open Sans",
    fontWeight: 700,
    letterSpacing: "-0.02em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "&lt;/&gt;")))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHtml);
export default __webpack_public_path__ + "static/media/html.089c55b89c47fc3ce507fc1d6540f8dc.svg";
export { ForwardRef as ReactComponent };